import { render, staticRenderFns } from "./AttrForm.vue?vue&type=template&id=1f2cb02c&"
import script from "./AttrForm.vue?vue&type=script&lang=js&"
export * from "./AttrForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports